module.exports = __webpack_public_path__ + "img/24_57.6d5371a4.png";